import { useRef as i, useEffect as d, useMemo as p, useCallback as g } from "react";
import { u as m } from "./use-unique-id-BA9hSqap.js";
import { n as h } from "./noop-ClDc6zv4.js";
const a = (e) => e && e.ownerDocument || document, f = (e) => a(e).defaultView || window, b = (e) => Math.abs(window.innerWidth - e.documentElement.clientWidth), v = (e) => parseInt(f(e).getComputedStyle(e).paddingRight, 10) || 0, C = (e) => {
  const o = a(e);
  return o.body === e ? f(e).innerWidth > o.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}, S = (e) => {
  const o = [];
  if (C(e)) {
    const n = b(a(e));
    o.push({
      value: e.style.paddingRight,
      property: "padding-right",
      el: e
    }), e.style.paddingRight = `${v(e) + n}px`;
    let t;
    if (e.parentNode instanceof DocumentFragment)
      t = a(e).body;
    else {
      const s = e.parentElement, r = f(e);
      t = (s == null ? void 0 : s.nodeName) === "HTML" && r.getComputedStyle(s).overflowY === "scroll" ? s : e;
    }
    o.push(
      {
        value: t.style.overflow,
        property: "overflow",
        el: t
      },
      {
        value: t.style.overflowX,
        property: "overflow-x",
        el: t
      },
      {
        value: t.style.overflowY,
        property: "overflow-y",
        el: t
      }
    ), t.style.overflow = "hidden";
  }
  return o;
}, y = (e) => {
  e.forEach(({ value: o, el: n, property: t }) => {
    o ? n.style.setProperty(t, o) : n.style.removeProperty(t);
  });
}, Q = (e = !1, o = document == null ? void 0 : document.body) => {
  const n = i(!1), t = i([]);
  d(() => {
    if (n.current !== e)
      return n.current = e, e ? t.current = S(o) : (y(t.current), t.current = []), () => {
        y(t.current), t.current = [];
      };
  }, [e, o]);
}, E = {
  enabled: !0
}, L = (e, o) => e.key === o || e.code === o || e.keyCode === o || e.which === o || e.charCode === o;
function k(e, o, n) {
  const t = p(
    () => ({ ...E, ...n }),
    [n]
  ), { enabled: s } = t, r = i(o);
  d(() => {
    r.current = o;
  });
  const u = g(
    (l) => {
      var c;
      L(l, e) && ((c = r.current) == null || c.call(r, l));
    },
    [e]
  );
  d(() => s && typeof window < "u" ? (window.addEventListener("keydown", u), () => {
    window.removeEventListener("keydown", u);
  }) : h, [s, e, o, u]);
}
const W = (e) => {
  const o = m("modal-lock");
  d(() => (window.CurologyBodyLockQueue = window.CurologyBodyLockQueue || {}, e ? window.CurologyBodyLockQueue[o] = !0 : delete window.CurologyBodyLockQueue[o], document.body.classList.toggle(
    "cur-overflow-hidden",
    !!Object.keys(window.CurologyBodyLockQueue).length
  ), () => {
    var n;
    (n = window.CurologyBodyLockQueue) == null || delete n[o];
  }), [o, e]);
}, w = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), audio[controls], video[controls], [contenteditable]:not([contenteditable="false"])', R = (e, o = !1, n = void 0) => {
  const t = i(null), s = g(
    (r) => {
      if (!e) return;
      const u = e.querySelectorAll(w), l = u[0], c = u[u.length - 1];
      r.shiftKey && document.activeElement === l ? (r.preventDefault(), c == null || c.focus()) : document.activeElement === c && (r.preventDefault(), l == null || l.focus());
    },
    [e]
  );
  d(() => {
    if (o && e) {
      t.current = document.activeElement;
      const r = n && e.querySelector(n) || e.querySelector(w);
      r == null || r.focus();
    }
    return () => {
      var r;
      (r = t.current) == null || r.focus();
    };
  }, [e, o, n]), k("Tab", s, { enabled: o });
};
export {
  k as a,
  W as b,
  R as c,
  L as d,
  Q as u
};
//# sourceMappingURL=use-trap-focus-jtnCyC_f.js.map
